var map = {
  "./AccountManagementPage": "24073",
  "./BidPage": "42678",
  "./BidResponsesPage": "9369",
  "./BidsPage": "43937",
  "./BuyerDetailsPage": "39468",
  "./BuyersPage": "86511",
  "./ContactsPage": "20013",
  "./ContentLibrary": "57260",
  "./CustomBriefingsPage": "76762",
  "./DocumentDetailsPage": "54468",
  "./DocumentsPage": "44929",
  "./FrameworkDetailsPage": "79641",
  "./FrameworkListPage": "6659",
  "./GuestPassRetiredPage": "74294",
  "./HomepagePage": "83579",
  "./IndustryReportsPage": "44479",
  "./InvitationExpiredPage": "17502",
  "./LeadDetailsPage": "66368",
  "./LeadsPage": "73203",
  "./MyNoticesPage": "41167",
  "./NoticeDetailsPage": "753",
  "./NoticeListsPage": "38709",
  "./NoticesAnalysisPage": "54918",
  "./NoticesV2Page": "18403",
  "./OnboardingPage": "7744",
  "./OscarSearchPage": "58872",
  "./PrintReportPage": "82618",
  "./ReportPage": "50192",
  "./RouterApp": "21635",
  "./SpendDataPage": "80023",
  "./SupplierBuyerRelationshipPage": "76038",
  "./SupplierProfilePage": "18640",
  "./SupplierSearchPage": "24690",
  "./UnsubscribePage": "31596"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 18853;
